import { API_CACHE_KEYS, API_PATHS } from '@/modules/common/constants';
import { ApiClient } from '@pw-tech/web-sdk';
import { useMutation } from '@tanstack/react-query';

export const useVerifyPayment = () => {
  const { isLoading, isPending, error, mutate, mutateAsync } = useMutation(
    [API_CACHE_KEYS.VERIFY_PAYMENT],
    (body: any) => {
      return ApiClient.post(API_PATHS.VERIFY_PAYMENT, body);
    }
  );

  return {
    error,
    isLoading,
    isPending,
    mutate,
    mutateAsync,
  };
};
